<div class="microsoft-button" (click)="connect()">
  <!--  <cf-button color="secondary" class="w-100">-->
  <cf-icon icon="microsoft_calendar" class="ms-0"></cf-icon>
  <ng-content></ng-content>
  <!--  </cf-button>-->
</div>
